import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '仪表盘', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    meta: { title: '用户管理', icon: 'user', roles: ['admin'] },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/list.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: 'device-binding',
        name: 'DeviceBinding',
        component: () => import('@/views/user/device-binding.vue'),
        meta: { title: '设备绑定管理' }
      },
      {
        path: 'user-devices',
        name: 'UserDevices',
        component: () => import('@/views/user/user-devices.vue'),
        meta: { title: '用户设备列表' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/list',
    meta: { title: '账号管理', icon: 'key', roles: ['admin'] },
    children: [
      {
        path: 'list',
        name: 'AccountList',
        component: () => import('@/views/account/list.vue'),
        meta: { title: '账号列表' }
      },
      {
        path: 'stats',
        name: 'AccountStats',
        component: () => import('@/views/account/stats.vue'),
        meta: { title: '使用统计' }
      },
      {
        path: 'rule',
        name: 'AccountRule',
        component: () => import('@/views/account/rule.vue'),
        meta: { title: '使用规则' }
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    redirect: '/content/notice',
    meta: { title: '内容管理', icon: 'document', roles: ['admin'] },
    children: [
      {
        path: 'notice',
        name: 'NoticeManage',
        component: () => import('@/views/content/notice.vue'),
        meta: { title: '公告管理' }
      },
      {
        path: 'banner',
        name: 'BannerManage',
        component: () => import('@/views/content/banner.vue'),
        meta: { title: '轮播图管理' }
      }
    ]
  },
  {
    path: '/payment',
    component: Layout,
    redirect: '/payment/merchant',
    name: 'Payment',
    meta: { title: '支付管理', icon: 'money' },
    children: [
      {
        path: 'merchant',
        name: 'PaymentMerchant',
        component: () => import('@/views/payment/merchant.vue'),
        meta: { title: '商户管理' }
      },
      {
        path: 'order',
        name: 'PaymentOrder',
        component: () => import('@/views/payment/order.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'test',
        name: 'PaymentTest',
        component: () => import('@/views/payment/test.vue'),
        meta: { title: '支付测试' }
      }
    ]
  },
  {
    path: '/esp8266',
    component: Layout,
    redirect: '/esp8266/device',
    name: 'ESP8266',
    meta: { title: 'ESP8266管理', icon: 'cpu' },
    children: [
      {
        path: 'device',
        name: 'Device',
        component: () => import('@/views/esp8266/device'),
        meta: { title: '设备管理' }
      },
      {
        path: 'firmware',
        name: 'Firmware',
        component: () => import('@/views/esp8266/firmware'),
        meta: { title: '固件管理' }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/esp8266/logs'),
        meta: { title: '设备日志' }
      },
      {
        path: 'task',
        name: 'Task',
        component: () => import('@/views/esp8266/task'),
        meta: { title: '任务管理' }
      },
      {
        path: 'assignment',
        name: 'Assignment',
        component: () => import('@/views/esp8266/assignment'),
        meta: { title: '任务分配' }
      },
      {
        path: 'stats',
        name: 'Stats',
        component: () => import('@/views/esp8266/stats'),
        meta: { title: '任务统计' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: Layout,
    redirect: '/dashboard',
    hidden: true
  }
]

export const asyncRoutes = []

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: constantRoutes
})

export default router
